import { DeliveryZonesStoreActionsClass } from './DeliveryZonesStoreActionsClass';

const DeliveryZonesStore: DeliveryZonesStoreActionsClass = new DeliveryZonesStoreActionsClass();

export { DeliveryZonesStore };
